<template>


  <!--begin::Profile 4-->
  <div class="row">
    <!--begin::Aside-->
    <div class="col-md-4" id="kt_profile_aside">
      <!--begin::Card-->
      <div class="card card-custom gutter-b">

        <div v-if="load" class="card-body">

          <div  class="text-center mb-10">
            <b-spinner variant="primary" label="Text Centered"></b-spinner>
          </div>
        </div>


        <!--begin::Body-->
        <div v-else class="card-body">

          <!--begin::Contact-->
          <div class="pt-8 pb-2">

            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="font-weight-bold mr-2">Имя:</span>
              <span class="text-muted">{{order.contact_name}}</span>
            </div>
            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="font-weight-bold mr-2">Телефон:</span>
              <span class="text-muted">{{order.contact_phone}}</span>
            </div>
            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="font-weight-bold mr-2">Email:</span>
              <a href="#" class="text-muted text-hover-primary">{{order.contact_email}}</a>
            </div>

            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="font-weight-bold mr-2">Название товара:</span>
              <a href="#" class="text-muted text-hover-primary">{{order.name}}</a>
            </div>

            <div class="pt-8 pb-2">
              <div class="d-flex align-items-center justify-content-between">
                <span class="font-weight-bold mr-2">Описание товара:</span>
              </div>
            </div>

            <!--end::Contact-->

            <!--begin::Contact-->
            <div class="pb-6">
              {{order.description}}
            </div>


            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="font-weight-bold mr-2">Количество:</span>
              <a href="#" class="text-muted text-hover-primary">{{order.qty}}</a>
            </div>

            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="font-weight-bold mr-2">Желаемая стоимость:</span>
              <a href="#" class="text-muted text-hover-primary">{{order.desired_value}}</a>
            </div>

            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="font-weight-bold mr-2">Желаемый срок доставки:</span>
              <a href="#" class="text-muted text-hover-primary">{{order.desired_delivery_time}}</a>
            </div>

          </div>


        </div>


      </div>
    </div>

    <div class="col-md-8">
      <!--begin::Row-->

      <!--begin::Advance Table Widget 8-->
      <div class="card card-custom gutter-b">
        <!--begin::Header-->
        <div class="card-header border-0 py-5">
          <h3 class="card-title align-items-start flex-column">
            <span class="card-label font-weight-bolder text-dark">Файлы</span>
          </h3>
        </div>
        <!--end::Header-->

        <div v-if="load" class="text-center mb-10">
          <b-spinner variant="primary" label="Text Centered"></b-spinner>
        </div>

        <!--begin::Body-->
        <div v-else class="card-body pt-0 pb-3">


          <div class="row">

            <div v-bind:key="i" v-for="(file, i) in order.files" class="col-xl-3 col-lg-6 col-md-6 col-sm-6">
              <div class="card card-custom gutter-b card-stretch">
                <div class="card-body pt-4">


                  <div class="d-flex align-items-center mb-7">
                    <b-img :src="$urlBackEnd(file.src)" fluid-grow alt="Fluid-grow image"></b-img>
                  </div>

                </div>
                <!--end::Body-->
              </div>
              <!--end::Card-->
            </div>

          </div>

        </div>

      </div>
    </div>

  </div>



</template>

<script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import {GET_ORDER_TABLE} from "../../../core/services/store/orders.module";
export default {
  name: "orderTable",

  mounted(){

    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Все заказы", route: "/order-tables" },
      { title: "Заказ" }
    ]);
    this.$store.dispatch(GET_ORDER_TABLE, this.$route.params.id);
  },

  computed: {
    ...mapGetters({
      order: 'gettersOrderTable',
      load: 'getOrderLoad',
      errors: 'errorsOrders',
    }),
  },

  methods:{



  }

}
</script>

<style scoped>

</style>